import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { DownloadFileService } from '../../../shared/services/download-file.service';
import { ApiService } from '../../../shared/services/api.service';
import { Urls } from '../../../utils/urls';
import { response } from 'express';
import { CommonDataService } from "@shared/services/common-data.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-statuory',
  templateUrl: './statuory.component.html',
  styleUrls: ['./statuory.component.scss']
})
export class StatuoryComponent implements OnInit {
  activeId = 0;

  topicList: any = [];

  statutoryList = [];

  subSection: any;

  section: any;

  months = [];

  year = [];

  isMobile = false;
  type: string = '';
  constructor(public downloadFileService: DownloadFileService,
    private apiService: ApiService,
    private router : Router,
    private commonDataService: CommonDataService,private activatedRoute: ActivatedRoute) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.type = params['type'] || '';
      });
     }

  ngOnInit() {
    this.scrollTop();
    this.getFiles();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getFiles = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getPartnerFiles, { type: 'Disclosure' }).subscribe((response: any) => {
      if (response.data.typeList) {
        this.topicList = response.data.typeList;
        const requestedIndex = this.topicList.findIndex((item: any) => item.subType.toLowerCase() === this.type.toLowerCase());
        if(requestedIndex !== -1) {
          this.setActive(requestedIndex);
        } else if(this.topicList.length) {
          this.setActive(0);
        }
        this.commonDataService.loaderStatus.next(false);
      }
    });
  }

  setActive = (id: number) => {
    this.activeId = id;
    this.router.navigate([], { queryParams: { type: this.topicList[id].subType } });
  }

  viewFile = (path: string | URL | undefined) => {
    window.open(path, '_blank');
  }


  public downloadFile(path: string) {
    const fileName = path.split("/").pop();
    this.downloadFileService.export(path).subscribe(data => saveAs(data, fileName));
  }


  toggleSection(item: any) {
    item.hide = !item.hide;
  }

  onMobileView(status: boolean) {
    this.isMobile = status;
  }

}
